module.exports = __webpack_public_path__ + "media/images/meta/clubpilates/apple-touch-icon_whitebg-b57733393abd09748ae18c678d4d6aa9.png";